import rootPath from "../routes-path";

export { RouteProps } from "../routes-path";

export const path = "/udaje-op";

export default rootPath + path;

export const licence = '/licence';
export const licencePath = path + licence;